import { createContext } from "preact";
import { useContext, useState } from "preact/hooks";
import type { ComponentChildren } from "preact";

interface AgentData {
  image_url: string;
  first_video_url: string;
  max_conv_dur: number;
}

interface AgentContextType {
  agentData: AgentData | null;
  setAgentData: (data: AgentData) => void;
}

const AgentContext = createContext<AgentContextType | undefined>(undefined);

interface AgentProviderProps {
  children: ComponentChildren;
}

export function AgentProvider({ children }: AgentProviderProps) {
  const [agentData, setAgentData] = useState<AgentData | null>(null);

  return (
    <AgentContext.Provider value={{ agentData, setAgentData }}>
      {children}
    </AgentContext.Provider>
  );
}

export function useAgent(): AgentContextType {
  const context = useContext(AgentContext);
  if (!context) {
    throw new Error("useAgent must be used within an AgentProvider");
  }
  return context;
}

